import { organisationRoutes } from '@/Organisation/organisation.routes';
const organisationModule = {
    routes: organisationRoutes
};
export default organisationModule;
